/** Tiefe Kopie für reines JSON (der gesamte Zustand ist JSON — keine Dates, keine Klassen). */
export function clone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
